import React from 'react';
import Button from '../button/button';
import { buildVersionedClass } from '@op/opds.opux-utilities';
import { IconClose } from '@op/opds.opux-icons/navigation';
import { useLocale } from '../common/locale';
import { closeButtonMessages } from './_messages';
const AlertCloseButton = _ref => {
  let {
    buttonRef,
    flash,
    handleKeyDown,
    hide
  } = _ref;
  const lc = useLocale();
  return /*#__PURE__*/React.createElement(Button, {
    "aria-live": "off",
    className: buildVersionedClass('ds-alert__close'),
    compact: flash,
    ghost: true,
    icon: IconClose,
    iconLabel: closeButtonMessages[lc].close,
    iconProps: {
      color: 'default'
    },
    onClick: ev => hide(ev),
    onKeyDown: ev => handleKeyDown(ev),
    ref: buttonRef,
    size: "default",
    tabIndex: 0,
    type: "button"
  });
};
export default AlertCloseButton;